import { combineReducers } from 'redux';

// Common
import UserReducers from './common/UserReducers';
import MeReducers from './common/MeReducers';
// feature
import RoleTypesReducer from './features/RoleTypesReducer';
import RoleReducer from './features/RoleReducer';
import EmployeeReducer from './features/EmployeeReducer';
import ProjectReducer from './features/ProjectReducer';
import BudgetReducer from './features/BudgetReducer';
import ExpensesReducer from './features/ExpensesReducer';
import InfoReducers from './features/InfoReducers';
import NotifyReducer from './features/NotifyReducer';
import CustomerReducer from './features/CustomerReducer';
import CustomerTypeReducer from './features/CustomerTypeReducer';
import DepartmentReducer from './features/DepartmentReducer';
import TimestampReducer from './features/TimestampReducer';
import TimestampPayrollReducer from './features/TimestampPayrollReducer';
import HolidayReducer from './features/HolidayReducer';
import BillingReducer from './features/BillingReducer';
import PayoutReducer from './features/PayoutReducer';
import PayinReducer from './features/PayinReducer';
import PaymentReducer from './features/PaymentReducer';
import PaytypeReducer from './features/PaytypeReducer';
import TransectionTypeReducer from './features/TransectionTypeReducer';
import SalaryReducer from './features/SalaryReducer';
import SalaryListReducer from './features/SalaryListReducer';
import SalaryDetailReducer from './features/SalaryDetailReducer';
import OtRequestReducer from './features/OtRequestReducer';
import OtRequestOrderReducer from './features/OtRequestOrderReducer';
import FieldAllowanceRequestOrderReducer from './features/FieldAllowanceRequestOrderReducer';
import ChatExpensesReducer from './features/ChatExpensesReducer';
import ManpowerReducer from './features/ManpowerReducer';
import ActivityLogReducer from './features/ActivityLogReducer';
import ContactReducer from './features/ContactReducer';
import DocumentReducer from './features/DocumentReducer';
import ItemTemplateReducer from './features/ItemTemplateReducer';
import ManualWorkEntryReducer from './features/ManualWorkEntryReducer';
import LeaveRequestReducer from './features/LeaveRequestReducer';
import PayrollAdjustmentReducer from './features/PayrollAdjustmentReducer';
import PayrollCarryoverReducer from './features/PayrollCarryoverReducer';
import VehicleFuelSettingReducer from './features/VehicleFuelSettingReducer';

const rootRuducer = combineReducers({
  me: MeReducers,
  user: UserReducers,
  roletype: RoleTypesReducer,
  role: RoleReducer,
  employee: EmployeeReducer,
  project: ProjectReducer,
  budget: BudgetReducer,
  expenses: ExpensesReducer,
  notify: NotifyReducer,
  info: InfoReducers,
  customer: CustomerReducer,
  customerType: CustomerTypeReducer,
  department: DepartmentReducer,
  timestamp: TimestampReducer,
  timestampPayroll: TimestampPayrollReducer,
  holiday: HolidayReducer,
  billing: BillingReducer,
  payout: PayoutReducer,
  payin: PayinReducer,
  payments: PaymentReducer,
  paytypes: PaytypeReducer,
  transectionTypes: TransectionTypeReducer,
  salary: SalaryReducer,
  salaryList: SalaryListReducer,
  salaryDetail: SalaryDetailReducer,
  otRequest: OtRequestReducer,
  otRequestOrder: OtRequestOrderReducer,
  fieldAllowanceRequestOrder: FieldAllowanceRequestOrderReducer,
  chatExpenses: ChatExpensesReducer,
  manpower: ManpowerReducer,
  activityLog: ActivityLogReducer,
  contact: ContactReducer,
  document: DocumentReducer,
  itemTemplate: ItemTemplateReducer,
  manualWork: ManualWorkEntryReducer,
  payrollAdj: PayrollAdjustmentReducer,
  payrollCarryover: PayrollCarryoverReducer,
  leaveRequest: LeaveRequestReducer,
  vehicleFuelSetting: VehicleFuelSettingReducer,
});
export default rootRuducer;
